/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-caret-size',
  templateUrl: './theme-option-tooltips-caret-size.component.html',
  styleUrls: ['./theme-option-tooltips-caret-size.component.css']
})
export class ThemeOptionTooltipsCaretSizeComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_caretSize';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_caretSize', value);
  }

}
